import { getRegisterFunction } from '../../utils/register.js';
import { OneUxAdapterElement } from './OneUxAdapterElement.js';
export const register = getRegisterFunction(OneUxAdapterElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-adapter': OneUxAdapterElement;
    "adapter-774969bf8cf4c97858a7e0856ba7650c": OneUxAdapterElement;
  }
}